import { matchVersion } from '../../utils';
import __regexp from './__windows-regexp';
/** Detect the Windows OS Version */
export default function isWindowsVersion(operator, version) {
	return function (ua) {
		var v;
		var r = 'auto';
		switch (version) {
			case 'XP':
				v = 5.1;
				break;
			case 7:
				v = 6.1;
				break;
			case 8:
				v = 6.2;
				break;
			case 8.1:
				v = 6.3;
				break;
			case 'Vista':
				v = 6;
				r = 'float';
				break;
			case 10:
				v = 10;
				r = 'int';
				break;
		}
		if (typeof v === 'number') {
			return matchVersion({
				ua: ua,
				version: v,
				operator: operator,
				regExp: __regexp,
				reductionToNumber: r,
				groupIndex: 2
			});
		} else {
			return false;
		}
	};
}
